export const OpenModalById = (modalId) => {
  document.getElementById(modalId)?.M_Modal.open();
};